import { render, staticRenderFns } from "./ButtonsMenu.vue?vue&type=template&id=20607100"
import script from "./ButtonsMenu.vue?vue&type=script&lang=js"
export * from "./ButtonsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports